/**
 * Pager component exported items
 */
export * from './pager';
export * from './external-message';
export * from './numeric-container';
export * from './pager-message';
export * from './pager-dropdown';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@syncfusion/ej2-grids/src/pager/index.js
// module id = 1164
// module chunks = 0